import { createAction, props } from "@ngrx/store";
import { MttConfig, RingConfig, SngConfig } from "./freePlayLobby.state";

export const addRingConfig = createAction(
    '[FreePlayLobby] Add Ring Config',
    props<{
        ringConfig: RingConfig;
    }>()
);

export const addSngConfig = createAction(
    '[FreePlayLobby] Add Sng Config',
    props<{
        sngConfig: SngConfig;
    }>()
);

export const addMttConfig = createAction(
    '[FreePlayLobby] Add Mtt Config',
    props<{
        mttConfig: MttConfig;
    }>()
);

export const removeRingConfig = createAction(
    '[FreePlayLobby] Remove Ring Config',
    props<{
        gameConfigId: string;
    }>()
);

export const removeSngConfig = createAction(
    '[FreePlayLobby] Remove Sng Config',
    props<{
        gameConfigId: string;
    }>()
);

export const removeMttConfig = createAction(
    '[FreePlayLobby] Remove Mtt Config',
    props<{
        gameConfigId: string;
    }>()
);

export const resetState = createAction(
    '[FreePlayLobby] Reset State'
);

export const rngConfigLoaded = createAction(
    '[FreePlayLobby] Rng config loaded'
);

export const sngConfigLoaded = createAction(
    '[FreePlayLobby] Sng config loaded'
);

export const mttConfigLoaded = createAction(
    '[FreePlayLobby] Mtt config loaded'
);
